export enum AptPaymentType {
    Rateizzo = 'Rateizzo',
    UnicaSoluzione = 'Unica Soluzione',
    AccontoSaldo = 'Acconto/Saldo',
    Consumo = 'A Consumo',
    Canone = 'Canone',
    AccontoSaldoRateizzo = 'Acconto e saldo rateizzato',
    AccontoSaldoUnicaSoluzione = 'Acconto e saldo in unica soluzione'
}
